<template lang="pug">
  include RegisterSelectPack.pug
</template>

<script>
import _ from 'underscore'
import PrivateRouterLink from '@/directives/PrivateRouterLink'
import Api from "@/components/services/Api";
import { mapState } from 'vuex';
import PermissionHandler from "@/components/services/Permissions"

const fixName = function(item) {
  if (item.front_name && item.front_name.length) return item.front_name
  return item.name
}

const findPermission = function(plan, key, items) {
  let isChecked = true

  _.each(items, item => {
    if (item.name == key) {
      if (!item.enabled) isChecked = false
    }
  })

  return isChecked
}

const findVisibility = function(plan, key, items) {
  let isVisible = true

  _.each(items, item => {
    if (item.name == key) {
      if (!item.visible) isVisible = false
    }
  })

  return isVisible
}

export default {
  name: 'RegisterSelectPack',
  props: [],
  components: {
    PrivateRouterLink,
  },
  computed: mapState([
    "context", "token",
  ]),
  data() {
    return {
      level: "",
      hasLevel: false,
      plan: "",
      uuid: null,
      permissions: [],
      planPermissions: {
        basic: [],
        estandar: [],
        premium: [],
      }
    }
  },
  async created() {
    const meResponse = await Api.me(this.token)
    const data = meResponse.data
    this.plan = data.plan
    this.level = data.level
    this.hasLevel = !_.isEmpty(this.level)
    this.uuid = data.uuid

    const permResponse = await Api.getPermissions(this.token)
    const data2 = permResponse.data

    const permissions = []

    // using premium as reference
    data2.premium.forEach(item => {
      const key = item.name
      item.name = fixName(item)

      item.on_basic = findPermission("basic", key, data2.basic)
      item.on_estandar = findPermission("estandar", key, data2.estandar)
      item.on_premium = findPermission("premium", key, data2.premium)

      item.visible_basic = findVisibility("basic", key, data2.basic)
      item.visible_estandar = findVisibility("estandar", key, data2.estandar)
      item.visible_premium = findVisibility("premium", key, data2.premium)

      // premium
      permissions.push(item)
    })

    this.planPermissions.basic = data2.basic
    this.planPermissions.estandar = data2.estandar
    this.planPermissions.premium = data2.premium

    this.permissions = _.chunk(permissions, 3)
  },
  methods: {
    selectFree() {
      this.$router.push({
        name: "RegisterFinish",
      })
    },
    selectPlan(plan) {
      const callback = `${window.location.protocol}//${window.location.host}/registro-profesional/final`
      let getUrl = `${Api.getApiUrl()}/esreps/renew-license/${this.uuid}/?plan=${plan}&callback=${callback}`
      window.location.href = getUrl
    }
  },
  filters: {
    fixedname: function(item) {
      return fixName(item)
    }
  }
}
</script>

<style lang="scss">
@import './../../variables';
@import './../../variables_colreps';

@import 'RegisterPacks';
@import 'RegisterFinish';
@import 'RegisterForm';
@import 'RegisterSelectPack';

</style>



// WEBPACK FOOTER //
// src/components/register/RegisterSelectPack.vue